import {Injectable} from "@angular/core";
import * as _  from "lodash";
import {LogCat, LogManager} from "../log";

@Injectable({ providedIn: 'root' })
  export class StringInterpolationService {
	private regExp=/\[\w+\]/gm;
	private removeBracketsRegExp=/\[|\]/g;

	public columnsListed(interpolationString:string):string[]{
		let columnsWithBrackets=interpolationString.match(this.regExp);
		if (!columnsWithBrackets){
			LogManager.error(LogCat.Utils.StringInterporlation,"no interpolation columns found for pattern "+interpolationString);
			return [];
		}else{
			return columnsWithBrackets.map(x=>x.replace(this.removeBracketsRegExp,''));
		}
	}

	public columnToProp(columnName:string){
		return _.camelCase(columnName);
	}
	public interpolate(jsonData:any, interpolationString:string, replaceIfEmpty?:string):string{
		let returnData=interpolationString;
		let properties = interpolationString.match(this.regExp);
		if (!properties){
			LogManager.error(LogCat.Utils.StringInterporlation,"no interpolation columns found for pattern "+interpolationString);
		}else {
			properties.forEach(currMatch => {
					let justProperty = currMatch.replace(this.removeBracketsRegExp, '');
					let camelCase = this.columnToProp(justProperty);//_.camelCase(justProperty);
					let data = (jsonData || {})[camelCase];
					if (data) {
						returnData = returnData.replace(currMatch, data);
					} else {
						if (replaceIfEmpty) {
							returnData = returnData.replace(currMatch, replaceIfEmpty);
						} else {
							returnData = returnData.replace(currMatch, '');
						}
					}
				}
			);
		}
		return returnData;
	}
}
